const statuses = require( '../enums/FormStatuses');
const alertTexts = require( '../enums/AlertTexts');

var formUnsavedMixin = {
    data: function () {
        return {
            status: statuses.FORM_STATUS.NO_ACTION,
            alertText: alertTexts.CHANGES_UNSAVED,
            openAlert: false,
            intendedRoute: {},
            alertType:alertTexts.ALERT_TYPES.WARNING,
            excludePath: [],
            okCall: ()=>true
        }
    },
    beforeRouteLeave(to, from, next) {
        let exclude = this.excludePath.find(path => to.path.includes(path));

        if(this.status !== statuses.FORM_STATUS.NO_ACTION || exclude || !this.isFormDirty()) {
            next();
            return;
        }

        this.intendedRoute = to.path;
        this.alertType = alertTexts.ALERT_TYPES.WARNING;
        this.alertText = alertTexts.CHANGES_UNSAVED;
        this.status=  statuses.FORM_STATUS.NO_ACTION;
        this.openAlert = true;
        this.okCall = (event) => this.alertClosed(event)
        return;
    },
    methods: {
        alertClosed($event){
            this.openAlert = false;
            if($event){
                this.resetValues();
                this.status = statuses.FORM_STATUS.CLOSE;
                this.$router.push(this.intendedRoute);
            }
        },
        isFormDirty() {
            return this.$v.$anyDirty;
        }
    }
}

export {
    formUnsavedMixin,
}